export function getMessage(err: unknown): string {
  if (err instanceof Error) {
    return err.message;
  }
  if (
    err instanceof Object
    && 'message' in err
    && typeof err.message === 'string'
  ) {
    if ('details' in err) {
      return `${err.message} (${err.details as any})`;
    }
    return err.message;
  }
  return String(err);
}
